import React, {useState, useEffect, useMemo} from 'react';

export const EditTimer: React.FC = () => {
    const [isRedActive, setIsRedActive] = useState(true);

    const intervalMs = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        const intervalString = params.get('interval');
        let num = parseInt(intervalString || '5');

        if (isNaN(num) || num < 1 || num > 999999) {
            num = 5;
        }
        return num * 1000;
    }, []);

    useEffect(() => {
        const timerId = setInterval(() => {
            setIsRedActive(prev => !prev);
        }, intervalMs);

        return () => clearInterval(timerId);
    }, [intervalMs]);

    return (
        <>
            <div
                id="RectangleRed"
                style={{opacity: isRedActive ? 1 : 0}}
            />
            <div
                id="RectangleBlue"
                style={{opacity: isRedActive ? 0 : 1}}
            />
        </>
    );
};
